import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { useContext, useState } from "react";
import InputV1 from "_+_Portal/components/Genericos/InputV1/InputV1";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import { wsGetMedicoPorMatricula } from "_+_Portal/_-_Autocheckin/context/action/medicoPorMatricula";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { proximoPaso } from "../PagesFun";
import {
  MedicoSolicitanteBody,
  MedicoSolicitanteContainer,
  MedicoSolicitanteContainerBotones,
  MedicoSolicitanteTitulo,
  ResumenBotones,
} from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";

const MedicoSolicitante = ({ turnoActual, setLoading }) => {
  // -------------------- Contexto --------------------
  const { toasterDispatch, toasterState } = useContext(GlobalContext);
  const {
    turnosSeleccionadosState,
    medicoPorMatriculaDispatch,
    pasoDispatch,
    rutaDispatch,
    rutaState,
    puntoControlDispatch,
  } = useContext(AutocheckContext);

  // -------------------- Contexto --------------------

  // -------------------- Constantes --------------------
  const listTurnosSeleccionado =
    turnosSeleccionadosState?.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado[turnoActual];

  const medico = turno?.medico;
  const especialidad = turno?.especialidad;

  // -------------------- Constantes --------------------

  const bodyTxt =
    "Ingresá la matrícula del médico que se encuentra en el sello de la orden.";

  const [matriculaMedico, setMatriculaMedico] = useState(null);

  // -------------------- Funciones --------------------

  const ingresarMatricula = (e) => {
    if (e.target.value.length >= 4) {
      setMatriculaMedico(e.target.value);
    }
  };
  const pressInput = (e) => {
    let key = e.key;
    if (key === "Enter") busquedaMedico();
  };

  const handleClickVolver = () => {
    setPaso("TurnosDelDia")(pasoDispatch);
  };

  const nextStep = (isCorrect, errorData) => {
    if (isCorrect) {
      setPaso("ConfirmarMedicoSolicitante")(pasoDispatch);
    } else {
      errorBusqueda(errorData);
    }
  };

  const noEncuentroOrden = () => {
    let ruta = rutaState?.ruta?.data ?? [];

    ruta = ruta.filter((item) => {
      if (item === "ValidarCobertura") {
        return false;
      } else {
        return true;
      }
    });

    if (ruta.length === 1) {
      const idTipoPuntoControl = 16;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    } else {
      setRuta(proximoPaso(ruta, setPaso, pasoDispatch))(rutaDispatch);
    }
  };

  const busquedaMedico = () => {
    setLoading("Cargando ...");
    setPaso("Loading")(pasoDispatch);
    wsGetMedicoPorMatricula(
      matriculaMedico,
      nextStep,
    )(medicoPorMatriculaDispatch);
  };

  const errorBusqueda = (errorData) => {
    showToaster(
      {
        texto: errorData?.userMessage || "La matricula ingresada es inválida.",
        tipo: "danger",
      },
      "centroArriba",
    )(toasterDispatch);
    setPaso("MedicoSolicitante")(pasoDispatch);
  };

  // -------------------- Funciones --------------------

  return (
    <LayoutPasos
      handleClick={handleClickVolver}
      volverTo={"/autocheckin/resumen"}
      type={"no-circle"}
      title={"Medico Solicitante"}
    >
      {toasterState.toaster.show && <ToasterV2 />}
      <CardBlueHeart
        medico={medico ? medico : especialidad}
        turnoTitle={especialidad}
        pasoActual={turnoActual + 1}
        pasoTotal={listTurnosSeleccionado.length}
      />
      <MedicoSolicitanteContainer
        initial={{ opacity: 0, y: +100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <PasoBar paso={"MedicoSolicitante"} />
        <MedicoSolicitanteTitulo>
          <span className="rb18m">Medico Solicitante</span>
        </MedicoSolicitanteTitulo>
        <hr className="ValidaTurno-separador"></hr>
        <MedicoSolicitanteBody>
          <span className="ValidaTurno-bodytxt">{bodyTxt}</span>
          <div className="ValidaTurno-input">
            <InputV1
              clase="ValidaTurno-input"
              placeholderText={"12254"}
              onChange={ingresarMatricula}
              onKeyPress={pressInput}
              inputType="number"
            />
          </div>
        </MedicoSolicitanteBody>
        <MedicoSolicitanteContainerBotones></MedicoSolicitanteContainerBotones>

        <ResumenBotones>
          <button onClick={busquedaMedico}>Buscar Médico</button>
          <button className="danger" onClick={noEncuentroOrden}>
            No la encuentro
          </button>
        </ResumenBotones>
      </MedicoSolicitanteContainer>
    </LayoutPasos>
  );
};

export default MedicoSolicitante;
